import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ProformaAPIURL from "../ProformaAPIURL";
import { GET, POST } from "../../../config/httpMain";
import { RoeModel } from "./interfaceRoe";

export const getRoe = createAsyncThunk('auth/getRoe', async (companyCode: string, thunkAPI: any) => {
    try {
        const response = await GET(ProformaAPIURL.GetRoe + "?CompanyCode=" + companyCode);
        return response.data;
    } catch (error: any) {
        return thunkAPI.rejectWithValue(error?.response?.data);
    }
});
export const addRoe = createAsyncThunk('auth/addRoe', async (payload: RoeModel, thunkAPI: any) => {
    try {
        const response = await POST(ProformaAPIURL.AddRoe, payload);
        return response.data;
    } catch (error: any) {
        return thunkAPI.rejectWithValue(error?.response?.data);
    }
});

export const roeSlice = createSlice({
    name: "roeSlice",
    initialState: {
        roe: null,
        isLoading: false,
        error: null,
    },
    reducers: {
        UpdateRoeData: (intialState: any, action: any) => {
            return {
                ...intialState,
                roe: action?.payload
            };
        },

    },
    extraReducers: (builder) => {
        builder
            .addCase(getRoe.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getRoe.fulfilled, (state, action) => {
                state.isLoading = false;
                if (action.payload.isSuccess) {
                    state.roe = action.payload.result;
                }
                else {
                    state.roe = null;
                    state.error = action.payload.resultMessage;
                }
            })
            .addCase(getRoe.rejected, (state: any, action: any) => {
                state.isLoading = false;
                state.error = action.payload?.resultMessage;
            });
    },
});

export const { UpdateRoeData } = roeSlice.actions;
export default roeSlice.reducer;